(function ($) {
  'use strict'

  var $w = $(window)
  var ua = window.navigator.userAgent
  var is_ie = ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0

  function scrollto (target, offset) {
    if (!target || !$(target).length) {
      return false
    }

    offset = offset || 0

    if (window.scroll && !is_ie) {
      window.scroll({
        top: $(target).offset().top - offset,
        left: 0,
        behavior: 'smooth'
      })
    } else {
      $('body, html').animate({
        scrollTop: $(target).offset().top - offset
      }, 500)
    }

    return true
  }

  $(function () {
    var $page_menus_2 = $('.page-menus-2');
    var $menu_list_section = $('.menu-list-section', $page_menus_2)
    var $menu_products = $('.menu-products', $page_menus_2)
    var $menu_products_listing = $('.menu-products__listing', $menu_products)
    var $title = $('.heading-top__title')

    function dietry_list_selected () {
      if ($('.menu-dietry-icons ul li').hasClass('active-dietry')) {
        var active_d = $('.menu-dietry-icons ul li.active-dietry').data('dietry')
        console.log(active_d)
        $('.product-item').hide()
        $('.dietry-notfound').hide()
        if (active_d == 'all') {
          $('.product-item').show()
        } else {
          $('.product-item.' + active_d).show()
          setTimeout(function () {
            if (!$('.product-item').hasClass(active_d)) {
              /*$('.menu-products__listing').append("<p>Not Found</p>");*/
              $('.dietry-notfound:first').show()
            }
          }, 1000)
        }
      }
    }

    function loading_products(params) {
      var data = $menu_products_listing.data('products') || {};

      if (!data.next && params.next !== 1) {
        return;
      }

      $menu_products_listing.addClass('loading')

      if ($menu_products_listing.data("xhr")) {
        $menu_products_listing.data("xhr").abort();
      }

      $menu_products_listing.data('xhr', $.ajax({
        url: adminurl,
        type: 'POST',
        data: {
          action: 'theme_ajax',
          type: 'products',
          params: params || {}
        },
        success: function (response) {
          if (response.success) {
            if (response.html) {
              $menu_products_listing[response.clear ? 'html' : 'append'](response.html)
            }
            data.next = response.next || 0
            $menu_products_listing.data('products', data)
            $title.html(params.title)
          }
        },
        complete: function () {
          $menu_products_listing.removeClass('loading')
          dietry_list_selected()
        }
      }))
    }

    $('.drop-trigger').on('click', function () {
      $('ul', $menu_list_section).slideToggle('slow').toggleClass('active')
      $(this).toggleClass('active')
    })

    $('a', $menu_list_section).on('click', function (e) {
      var $parent = $(this).closest('li')
      var category = $(this).data('category')
      var params = {next: 1, clear: 1, title: $(this).data('title') ? $(this).data('title') : $(this).html()}
      var data = $menu_products_listing.data('products') || {}

      if ($parent.hasClass('current')) {
        return
      }

      $('li', $menu_list_section).removeClass('current')
      $parent.addClass('current')

      if (category && category !== 'all') {
        params.category = category
        data.category = category
      } else {
        delete data.category
      }

      $menu_products_listing.data('products', data)

      scrollto($menu_products, $menu_list_section.height() + 20)
      loading_products(params)

      if (window.history && window.history.pushState) {
        let url = $page_menus_2.data('page-url')
        if (category && category !== 'all') {
          url += category + '/'
        }
        window.history.pushState({ category: category }, params.title, url)
      }

      e.preventDefault()
    })

    $('.menu-promoted__carousel').owlCarousel({
      loop: true,
      margin: 0,
      autoplay: false,
      // autoplayTimeout: 10000,
      // responsiveClass: true,
      items: 1,
      // nav: true,
      dots: true,
      navSpeed: 1000,
      autoplaySpeed: 1000,
      dotsSpeed: 1000,
      dragEndSpeed: 1000
    })

    $w.on('scroll', function () {
      var scrolltop = $w.scrollTop()
      var wheight = $w.height()
      var pheight = $menu_products_listing.height() + $menu_products_listing.offset().top

      if (!$menu_products_listing.hasClass('loading') && scrolltop + wheight > pheight) {
        loading_products($menu_products_listing.data('products'))
      }
    })

    $('#order-now-btn').on('click', function () {
      $('.order-now-btn a.order-button').trigger('click')
    })

    $('.map-close-popup').on('click', function (ev) {
      window.location.hash = ''
    });

    $w.trigger("resize");
    $w.trigger("scroll");

    $('.menu-promoted1').hide();
    $('.menu-promoted2').hide();
    $('.inner-menu-list ul li').on('click', 'a', function () {
      $('.menu-dietry-icons ul li').removeClass('active-dietry');
      $('.product-item').hide();
      var data_category = $(this).attr('data-category');
      var data_slug = $('.menu-promoted').attr('data-slug');
      var data_slug2 = $('.menu-promoted2').attr('data-slug');
      if (data_category == data_slug) {
        $('.menu-promoted1').show();
        $('.menu-promoted2').hide();
      } else if (data_category == data_slug2) {
        $('.menu-promoted1').hide();
        $('.menu-promoted2').show();
      } else {
        $('.menu-promoted1').hide();
        $('.menu-promoted2').hide();
      }
      $(".all_active").show();
    });

    $(window).load(function () {
      $('.menu-promoted1').hide();
      $('.menu-promoted2').hide();
      if ($(".inner-menu-list ul li").hasClass("current")) {
        var current_slug = $('.current a').attr('data-category');
        var data_slug = $('.menu-promoted1').attr('data-slug');
        var data_slug2 = $('.menu-promoted2').attr('data-slug');
        if (current_slug == data_slug) {
          $('.menu-promoted1').show();
          $('.menu-promoted2').hide();
        } else if (current_slug == data_slug2) {
          $('.menu-promoted1').hide();
          $('.menu-promoted2').show();
        } else {
          $('.menu-promoted1').hide();
          $('.menu-promoted2').hide();
        }
      }
      $(".all_active").show();
    });

    $(".menu-dietry-icons ul").on("click",'li', function () {
      $('.product-item').hide();
      $('.dietry-notfound').hide();
      $('html, body').animate({
        scrollTop: $(".menu-after-products").offset().top
      }, 1000);
      $('.menu-dietry-icons ul li').removeClass('active-dietry');
      $(this).addClass('active-dietry');
      var o_val = $(this).data('dietry');
      console.log('.product-item.'+o_val.length);
      if(o_val == "all"){

        $('.product-item').show();

      }else{

        $('.product-item.'+o_val).show();
        setTimeout(function(){
          if( !$('.product-item').hasClass(o_val) ){
            /*$('.menu-products__listing').append("<p>Not Found</p>");*/
            $('.dietry-notfound:first').show();
          }
        }, 1000);
      }
    });
  })
}(jQuery))